import React, { useState, useEffect } from 'react';
import { Container, Typography, Box, Paper, Stack } from '@mui/material';
import { StatsCards } from '../components/reports/StatsCards';
import { ChartsSection } from '../components/reports/ChartsSection';
import { ExportButton } from '../components/reports/ExportButton';
import { Loading } from '../components/common/Loading';
import { reportsService } from '../services/reports.service';
import { ReportData } from '../types/reports.types';
import toast from 'react-hot-toast';

export const ReportsPage: React.FC = () => {
  const [reportData, setReportData] = useState<ReportData | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadReportData();
  }, []);

  const loadReportData = async () => {
    setIsLoading(true);
    try {
      const data = await reportsService.getReportData();
      setReportData(data);
    } catch (error: any) {
      console.error('Failed to load report', error);
      toast.error('Failed to load report data');
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <Loading message="Loading reports..." />;
  }

  if (!reportData) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Paper sx={{ p: 4, textAlign: 'center' }}>
          <Typography variant="h6" color="text.secondary">
            No report data available
          </Typography>
        </Paper>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Stack direction="row" sx={{ justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <Typography variant="h4" gutterBottom>
            Reports & Analytics
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Comprehensive insights into your leads performance
          </Typography>
        </Box>
        <ExportButton />
      </Stack>

      <StatsCards stats={reportData.stats} />
      
      <ChartsSection
        statusDistribution={reportData.statusDistribution}
        sourceDistribution={reportData.sourceDistribution}
        leadsOverTime={reportData.leadsOverTime}
      />
    </Container>
  );
};